import { render } from "./OfferCategory.vue?vue&type=template&id=7cd2d724&scoped=true"
import script from "./OfferCategory.vue?vue&type=script&lang=js"
export * from "./OfferCategory.vue?vue&type=script&lang=js"

import "./OfferCategory.vue?vue&type=style&index=0&id=7cd2d724&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd2d724"]])

export default __exports__